@if (summaryData) {
  <div class="summary-container">
    <app-info-box title="{{ 'steps.summary.title' | translate }}" description="{{ 'steps.summary.description' | translate }}"></app-info-box>
    @if (type !== 'Consulto Veterinario') {
      <div class="profile-data-container">
        <h3>{{ 'steps.summary.profile_data' | translate }}</h3>
        <nz-divider></nz-divider>
        <div class="info-container">
          <div>
            <span class="title">{{ 'steps.summary.name' | translate }}</span>
            <p>{{ summaryData.user?.fullName }}</p>
          </div>
          <div>
            <span class="title">{{ 'steps.summary.telephone' | translate }}</span>
            <p>{{ summaryData.user?.phone }}</p>
          </div>
          <div>
            <span class="title">{{ 'steps.summary.email' | translate }}</span>
            <p>{{ summaryData.user?.email }}</p>
          </div>
        </div>
      </div>
    }
    @if (summaryData.appointment) {
      <div class="info-container-empty">
        <h3>{{ 'steps.summary.appointment_type' | translate }}</h3>
        <nz-divider></nz-divider>
        <div class="info-container">
          @if (summaryData.appointment?.type) {
            <div>
              <span class="title">{{ 'steps.summary.type' | translate }}</span>
              <p>{{ summaryData.appointment?.type }}</p>
            </div>
          }
          @if (summaryData.appointment?.specialty) {
            <div>
              <span class="title">{{ 'steps.summary.specialty' | translate }}</span>
              <p>{{ summaryData.appointment?.specialty?.description }}</p>
            </div>
          }
        </div>
      </div>
    }
    @if (summaryData.request) {
      <div class="info-container-empty">
        <h3>{{ 'steps.summary.request_type' | translate }}</h3>
        <nz-divider></nz-divider>
        <div class="info-container">
          @if (summaryData.request?.reason) {
            <div>
              <span class="title">{{ 'steps.summary.request_reason' | translate }}</span>
              <p>{{ summaryData.request.reason }}</p>
            </div>
          }
        </div>
      </div>
    }
    @if (summaryData.request?.documents?.length > 0) {
      <div class="info-container-empty documents">
        <p>{{ 'steps.summary.documents_loaded' | translate }}</p>
        <div class="list-documents-container">
          @for (document of summaryData.request.documents; track document.id) {
            <app-document-card [documentCardData]="document" [isPopoverVisible]="false"></app-document-card>
          }
        </div>
      </div>
    }
    @if (summaryData?.travel?.form?.value?.travel) {
      <div class="info-container-empty">
        <h3>{{ 'steps.summary.additional_info' | translate }}</h3>
        <nz-divider></nz-divider>
        <p class="subtitle">{{ 'steps.summary.additional_info_subtitle' | translate }}</p>
        <div class="info-container">
          <div>
            <span class="title">{{ 'steps.summary.start_date' | translate }}</span>
            <p>{{ formatDate(summaryData.travel.form.value.departure) }}</p>
          </div>
          <div>
            <span class="title">{{ 'steps.summary.end_date' | translate }}</span>
            <p>{{ formatDate(summaryData.travel.form.value.return) }}</p>
          </div>
          <div>
            <span class="title">{{ 'steps.summary.destination' | translate }}</span>
            <p>{{ summaryData.travel.destination }}</p>
          </div>
        </div>
      </div>
    }
    @if (summaryData.surveyValues) {
      <div class="info-container-empty">
        <h3>{{ 'steps.summary.actual_situation' | translate }}</h3>
        <nz-divider></nz-divider>
        <div nz-row class="info-container-radios">
          @for (answer of summaryData.surveyValues; track $index) {
            <div nz-col nz-span="24">
              <span class="title">{{ answer.surveyValueQuestion }}</span>
              <p>{{ answer.surveyValueAnswer }}</p>
            </div>
          }
        </div>
      </div>
    }
    @if (summaryData.dates) {
      <div class="info-container-empty">
        <h3>{{ 'steps.summary.date' | translate }}</h3>
        <nz-divider></nz-divider>
        <div class="info-container date">
          @for (date of summaryData.dates; track date) {
            <div>
              <span nz-icon nzType="calendar" nzTheme="outline"></span>
              <p>
                {{ date.date | date: 'dd/MM/yyyy' }},
                <strong>{{ formatTimeRange(date.time) }}</strong>
              </p>
            </div>
          }
        </div>
      </div>
    }
  </div>
}
